import * as React from 'react';
import  { withStyles } from '@mui/styles';
import URLManager from '~common/lib/url-manager';
import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import AppView from '~common/components/app-view/index';
import FormBasedEditor from '~common/form/form-based-editor';
import PortalUserContext from '../../../../../common/ui/lib/portal-user-context';

import DefinitionDataProvider from "~common/form/icg-definition-data-provider";
import FormBasedContainer from "~common/form/form-based-container-fc";
import {ContainerTypeEditor} from "~common/form/form-based-container-fc";

const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
}

type State = {
	// status: "loading" | "ready"
	// form: any;
	// data: any;
};

class Preferences extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
			// form: {},
			// data: {},
		};
	}


	UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {}

	render() {

    const {match} = this.props;
		const { classes }: { classes: ClassNameMap } = this.props;

		var selector = {"formType":"userPreferences", "form": "userPreferences", "modules": "users", "userType": PortalUserContext.userContext.userType == 'Vendor' ? 'Vendor' : "Any"}
		if (!PortalUserContext.userContext.extendedAttributes.hasPortalUserLogin) {
			selector["nonSSO"] = "true"
		} else {
			selector["nonSSO"] = "false"
		}

		return (
			<div className={classes.container}>
				<AppView history={this.props.history}>
					<DefinitionDataProvider>
						<FormBasedContainer
							containerType={ContainerTypeEditor} 
							history={this.props.history} 
							match={match}
							dataUrl="/api/portal-users/preferences"
							formSelector={selector}
							returnURL={URLManager.getQueryStringValueByKey("returnURL", window.location.href)}
						>
						</FormBasedContainer>
					</DefinitionDataProvider>
				</AppView>
			</div>
		);
	}
}

export default withStyles(styles)(Preferences);


